import Vue from 'vue';
import { USER_INFO } from "@/store/mutation-types";
var getters = {
  device: function device(state) {
    return state.app.device;
  },
  theme: function theme(state) {
    return state.app.theme;
  },
  color: function color(state) {
    return state.app.color;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    state.user.avatar = Vue.ls.get(USER_INFO).avatar;
    return state.user.avatar;
  },
  username: function username(state) {
    return state.user.username;
  },
  nickname: function nickname(state) {
    state.user.realname = Vue.ls.get(USER_INFO).realname;
    return state.user.realname;
  },
  welcome: function welcome(state) {
    return state.user.welcome;
  },
  permissionList: function permissionList(state) {
    return state.user.permissionList;
  },
  userInfo: function userInfo(state) {
    state.user.info = Vue.ls.get(USER_INFO);
    return state.user.info;
  },
  addRouters: function addRouters(state) {
    return state.permission.addRouters;
  }
};
export default getters;